/**
 * Lectura y validación de variables de entorno al arranque.
 * Todas son públicas (prefijo VITE_) — nunca contienen secretos.
 * Ver .claude/docs/PLAN.md §10.
 */

interface AppEnv {
  apiUrl: string;
  siteId: string;
  defaultLanguage: string;
}

function readEnv(): AppEnv {
  const apiUrl = import.meta.env.VITE_API_URL ?? '';
  const siteId = import.meta.env.VITE_SITE_ID ?? 'psicointegralis';
  const defaultLanguage = import.meta.env.VITE_DEFAULT_LANGUAGE ?? 'es';

  // En v0.1 la landing es estática y no requiere API; solo advertimos.
  if (!apiUrl && import.meta.env.PROD) {
    console.warn('[env] VITE_API_URL no está definida. Las llamadas al backend fallarán.');
  }

  return { apiUrl, siteId, defaultLanguage };
}

export const env: Readonly<AppEnv> = Object.freeze(readEnv());
